import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import SearchSvg from '../../svg/admin/Search';
import MoreSvg from '../../svg/admin/More';
import PageSelector from '../components/PageSelector';
import { fetchSchoolMissions, teacherUpdateSchoolMission } from '../../services2/schoolMissions.service';
import { useSetting } from '../../util/useSetting';
import DropDownSelection from './components/DropDownSelection';


const TEACHER_MATERIALS = [
    {
    type: '平台',
    name: '平台快速入門',
    subtitle:'從互文閱讀管理進入單元並完成第一個教學設定。',
    image: '/secondary/tasks/100.png'
  },
  {
    type: '模型視頻',
    name: '單元概念與閱讀觀念',
    subtitle:'重新思考閱讀的本質，以及中文閱讀教師在 AI 時代的專業角色。',
    image: '/secondary/tasks/101.png'
  },
  {
    type: '教育局文件',
    name: '數字閱讀與文本連結',
    subtitle:'辨析閱讀素養、文本類型與媒介差異，建立跨文本的連結方式。',
    image: '/secondary/tasks/102.png'
  },
]


function Component(props) {
    const { } = useParams();
    const navigate = useNavigate();
    let [searchParams, setSearchParams] = useSearchParams();
    const [data, setdata] = useState(TEACHER_MATERIALS)
    const [isLoading, setisLoading] = useState(false)
    const [total, settotal] = useState(TEACHER_MATERIALS.length)
    const { fontSize } = useSetting();


    const filter = searchParams.get('filter') || '全部';
    const category = searchParams.get('category') || '全部主題';
    const sorting = searchParams.get('sorting') || '全部';
    const page = parseInt(searchParams.get('page')) || 1;
    const limit = 4
    const totalPage = Math.ceil(total / limit) || 1

    const handleSelectPage = (p) => async () => {
        if (p > totalPage || p < 1) return;
        searchParams.delete('page')
        searchParams.set('page', p)
        setSearchParams(searchParams)
    }
    const handleUpdateSorting = (newValue) => {
        searchParams.delete('sorting')
        searchParams.set('sorting', newValue)
        setSearchParams(searchParams)
    }
    const handleUpdateCategory = (newValue) => {
        searchParams.delete('category')
        searchParams.set('category', newValue)
        setSearchParams(searchParams)
    }

    const fetchData = async (force = false) => {
        if (isLoading && !force) return
        setisLoading(true)
        // const filter = {}
        // // if (status !== '全部') filter.status = status
        // let result = await fetchSchoolMissions(props.token.token, filter, { limit, skip: (page - 1) * limit });
        // if (result.result) {
        //     setdata(result.result)
        //     settotal(result.count || 0)
        // } else {
        //     alert('Fetch data error')
        // }
        setisLoading(false)
    }



    useEffect(() => {
        fetchData()
    }, [searchParams])


    return (
        <div className='h-full flex-1 bg-[#EDF5F8] flex-col flex p-[16px] gap-[16px] overflow-auto' style={{ fontSize }}>
            {/*title, filter, serach box*/}
            <div className='p-[16px] flex flex-col items-start justify-start gap-[16px]'>
                <div className='text-[#4B555C] font-[700]' style={{fontSize: fontSize + 4}}>教師自學區｜培訓內容＋自學內容</div>
                <div className='flex flex-row gap-[16px]'> 
                    <DropDownSelection color='#009191' value={sorting} options={['排序', '最新', '最舊']} onUpdate={handleUpdateSorting} />  
                    <DropDownSelection color='#009191' value={category} options={['全部主題', '主題一', '主題二']} onUpdate={handleUpdateCategory} /> 
                </div>
            </div>
            {/*end of title, filter, serach box*/}

            {/*list of data*/}
            <div className='flex flex-row w-full flex-wrap px-[16px] justify-between items-stretch p-[16px] font-[600]'>
                {data?.map((item, index) =>
                    <div key={item?._id} className='flex flex-col justify-start items-start relative rounded-[16px] mt-[16px] min-w-[400px]' style={{boxShadow: '0 4px 6px rgba(0,0,0,0.1)',background:'linear-gradient(to left, #178E95, #07162F)',width:'calc(50% - 8px)' }}>
                        <div className='text-white font-[900] px-[16px] py-[8px]'>{item?.type}</div>
                        <div className='relaticve w-full rounded-[16px] overflow-hidden bg-[white] flex flex-col'  style={{aspectRatio:'736/342',height:undefined, backgroundImage: `url(${item?.image})`, backgroundSize: 'cover', backgroundPosition: 'center',}}>
                            <div className='absolute bottom-0 left-0 right-0 h-[60%] z-[1] rounded-[16px] overflow-hidden' style={{ background: 'linear-gradient(to top, rgba(255,255,255,1),rgba(255,255,255,1), rgba(0,0,0,0))' }} />
                            <div className='flex-1 w-full flex flex-row items-end z-[2]'>
                                <div className='flex-1 flex flex-col justify-end items-start p-[16px] gap-[16px]'>
                                    <div style={{fontSize: fontSize + 2}}>{item?.name}</div>
                                    <div style={{fontSize: fontSize}}>{item?.subtitle}</div>
                                </div>
                                <div className='p-[16px] noto-san-hk'>
                                    <button className='bg-[#009191] px-[48px] py-[8px] rounded-full text-[#A9FFDC]'>
                                       {' 開啟資源 >'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
               
            </div>
            {/*end of list of data*/}
            <PageSelector
                handleSelectPage={handleSelectPage}
                page={page}
                total={total}
                totalPage={totalPage}
            />
            {isLoading && <LoadingPage />}
        </div>
    );
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
